import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-send-notification-dialog',
  templateUrl: './send-notification-dialog.component.html',
  styleUrl: './send-notification-dialog.component.scss'
})
export class SendNotificationDialogComponent {
  selectedDriverLabel: any = null;
  message: string = '';

  constructor(
    public dialogRef: MatDialogRef<SendNotificationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  close() {
    this.dialogRef.close();
  }

  send() {
    this.dialogRef.close({
      driver: this.selectedDriverLabel,
    });
  }
}
